import React from "react";
import { Flex, FlexItem, Text } from "@fluentui/react-northstar";

export interface ReportBoxProps {
    title: string;
    content: React.ReactNode;
    noGap?: boolean;
    headerAddOn?: React.ReactNode;
}

export const ReportBox: React.FC<ReportBoxProps> = (props) => {
    return (
        <Flex column fill gap={props.noGap ? undefined : "gap.large"}>
            <Flex space="between" vAlign="center">
                <Text size="medium" weight="semibold">
                    {props.title}
                </Text>
                {props.headerAddOn}
            </Flex>
            {props.content}
        </Flex>
    );
};
